import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { Text } from '@naf/text';

export const StyledHeaderText = styled(Text)`
  margin: 0;
  overflow-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
`;

export const IngressWrapper = styled.div``;

export const Ingress = styled(Text)`
  margin-top: 0;
  margin-bottom: ${spacing.space40};
  max-width: 90%;

  @media (max-width: ${breakpoints.m}) {
    font-size: 1.25rem;
  }
`;

export const HRLine = styled.hr`
  border: 0;
  border-top: 3px solid ${nafColor.signature.yellow};
  width: 96px;
  margin: ${spacing.space4} 0 ${spacing.space32};
  color: ${nafColor.signature.yellow};
`;

export const MobileWrapper = styled.div<{ $extraMargin?: boolean }>`
  display: none;

  @media (max-width: ${breakpoints.m}) {
    display: block;
    margin-top: ${({ $extraMargin }) => ($extraMargin ? spacing.space40 : 0)};
  }
`;
